<template>
  <section class="highlight" name="highlight">
    <div class="container">
      <a-typography-title :level="1">
        九大亮点功能
      </a-typography-title>
      <a-row :gutter="[50,20]">
        <template v-for="(item,index) in expand.list">
          <a-col v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)||index<4||expand.active"
                 :xs="24" :md="12" :xl="8">
            <div class="item" :class="[`i_${index+1}`,`i_${index%2?'right':'left'}`]">
              <a-typography-title :level="5">
                {{ item.title }}
              </a-typography-title>
              <a-typography-paragraph>
                {{ item.text }}
              </a-typography-paragraph>
            </div>
          </a-col>
        </template>
        <a-col v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)"
               :span="24">
          <a-button type="link" class="button_more"
                    @click="expand.active=!expand.active">
            <template #icon>
              <DownCircleOutlined v-if="!expand.active" />
              <UpCircleOutlined v-else />
            </template>
          </a-button>
        </a-col>
      </a-row>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_2 button_n_2_w"
                  @click="clickToStore()">
          SaaS服务
        </a-button>
        <a-button type="link" class="button_n_2 button_n_2_w"
                  @click="clickToWhiteBook()">
          免费部署
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DownCircleOutlined, UpCircleOutlined } from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'home_highlight',
  components: {
    DownCircleOutlined,
    UpCircleOutlined
  },
  data(): DataInterface {
    return {
      expand: {
        active: false,
        list: [
          {
            title: '一站式AI应用管理',
            text: '集中管理所有AI应用和大模型，简化部署和维护流程'
          },
          {
            title: '丰富多样的AI应用',
            text: '最新AI应用不断上架，行业最热门AI应用一站全覆盖'
          },
          {
            title: '多厂商API集成',
            text: '无缝接入多家AI大模型提供商，无需单独商务对接，提供丰富的大模型选择'
          },
          {
            title: '多样化服务方式',
            text: '支持私有化部署、一体机、公有云托管、SaaS服务等众多服务方式'
          },
          {
            title: '信创一体机',
            text: '内置昇腾芯片、统信OS的预装信创一体笔记本，开机即用'
          },
          {
            title: '低成本部署',
            text: '支持笔记本电脑等低配置设备上实现多应用部署，降低硬件投资'
          },
          {
            title: '高效计算调度',
            text: '统筹优化GPU、CPU等资源调度，确保AI应用高效运行'
          },
          {
            title: 'Serverless架构',
            text: '无服务器管理，运维自动化，按需自动扩展或调度计算资源'
          },
          {
            title: '基于专利技术',
            text: '基于规格压测、流量压测等核心专利技术，一流研发团队确保高质量产品'
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 点击去商城
     */
    clickToStore(): void {
      // location.href = $Config.Href.store;
      open($Config.Href.store);
    },
    
    /**
     * 点击去云平台
     */
    clickToCloud(): void {
      // location.href = $Config.Href.cloud;
      open($Config.Href.cloud);
    },
    
    /**
     * 点击去白皮书
     */
    clickToWhiteBook(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open('https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd');
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/home/';

.highlight {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 @padding;
  .bg('@{image}highlight_bg.png');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_white, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @h: 120px;
  @wh: 80px;
  overflow: hidden;
  position: relative;
  width: 100%;
  max-width: 380px;
  height: @h;
  margin: 0 auto;
  background: @color_white;
  border-radius: 10px;
  .shadow(0 15px 25px fade(#0E2456, 30));
  
  &:hover {
    &::before {
      opacity: 0;
    }
    
    h5.ant-typography {
      color: @color_white;
      .transform(translate(0, -30px));
    }
    
    div.ant-typography {
      .transform(translateY(-100%));
      opacity: 1;
    }
  }
  
  .loop(@i) when (@i<=9) {
    &.i_@{i} {
      &::before {
        background-position: -(-1+@i)*@wh 0;
      }
    }
    
    .loop(@i+1);
  }
  .loop(1);
  
  &::before {
    content: '';
    display: block;
    .position(absolute, 50%, auto, auto, 50%);
    z-index: 0;
    width: @wh;
    height: @wh;
    .transform(translate(calc(~'-50% - 100px'), calc(~'-50% + 2px')));
    .bg('@{image}highlight_icon.png', @wh*9, @wh);
    .transition(opacity @time);
  }
  
  h5.ant-typography {
    @style: color @time, transform @time;
    .position();
    z-index: 2;
    width: 200px;
    height: @text_big+4px;
    margin: auto;
    .font(center, @text_big+4px, @color_12, @text_big+4px, true);
    .transform(translate(40px, 0));
    .transition(@style);
  }
  
  div.ant-typography {
    @style: opacity @time, transform @time;
    .position(top, 100%);
    z-index: 1;
    height: @h;
    padding: 55px 30px 0;
    margin: 0;
    .bg('@{image}highlight_item_bg.png');
    background-size: cover;
    .font(justify, @text+@line, @color_white, @text);
    opacity: 0;
    .transition(@style);
  }
}

.button_more {
  display: block;
  width: 100%;
  height: auto;
  padding: 5px 0;
  border: none;
  
  > * {
    .font(center, 30px, @color_white, 30px, true);
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_xl) {
  .item {
    &.i_left {
      float: right;
    }
    
    &.i_right {
      float: left;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .highlight {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+10px, @color_white, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    float: none !important;
    
    &::before {
      .transform(translate(calc(~'-50% - 60px'), calc(~'-50% + 2px')) scale(0.7));
    }
    
    h5.ant-typography {
      height: @text_big_mo;
      .font(center, @text_big_mo, @color_6, @text_big_mo, true) !important;
      .transform(translate(0, -30px)) !important;
    }
    
    div.ant-typography {
      padding: 50px 20px 0;
      .font(justify, @text_mo+@line, @color_13, @text_mo) !important;
      background: @color_white;
      opacity: 1;
      .transform(translateY(-100%)) !important;
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>